import Layout from "../../Internal/Layout.vue";
import Logs from "./Logs.vue";

const LogsRoutes = {
  component: Layout,
  children: [
    {
      path: "/logs",
      name: "Logs",
      component: Logs,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresManagerial: true,
      },
    },
  ],
};

export default LogsRoutes;
